const entries = [
  {
    name: '娱乐黑料', id: '娱乐黑料', desc: '圈内动向、舞台现场、节目后台，娱乐线边角料按类整理', num: '1.2w', cat: '粉丝向',
    img: 'https://readdy.ai/api/search-image?query=editorial%20magazine%20photography%20of%20a%20dramatic%20stage%20curtain%20with%20warm%20golden%20spotlight%20and%20film%20clapperboard%2C%20rich%20red%20and%20brown%20tones%2C%20cinematic%20grain%2C%20shallow%20depth%2C%20cohesive%20moody%20palette&width=520&height=320&seq=hero-ent-9h1&orientation=landscape',
  },
  {
    name: '网红黑料', id: '网红黑料', desc: '直播现场、带货翻车、人设考古，红人圈的每一场风波', num: '8.9k', cat: '现场向',
    img: 'https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20smartphone%20ring%20light%20and%20small%20desk%20microphone%20in%20a%20warm%20content%20studio%2C%20amber%20tones%2C%20cinematic%20grain%2C%20shallow%20depth%2C%20cohesive%20moody%20palette&width=520&height=320&seq=hero-net-9h1&orientation=landscape',
  },
  {
    name: '事件专区', id: '事件专区', desc: '每场大事从起点到现状，按时间线铺开全脉络', num: '436', cat: '脉络向',
    img: 'https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20vintage%20map%20with%20marked%20timeline%20route%20and%20pins%20on%20an%20aged%20wooden%20desk%2C%20warm%20lamplight%2C%20brown%20and%20cream%20tones%2C%20film%20grain%2C%20cohesive%20moody%20palette&width=520&height=320&seq=hero-ev-9h1&orientation=landscape',
  },
  {
    name: '黑料盘点', id: '黑料盘点', desc: '季度榜单、主题归档，把散料攒成能读的盘点', num: '57', cat: '榜单向',
    img: 'https://readdy.ai/api/search-image?query=editorial%20photography%20of%20tall%20stacks%20of%20categorised%20files%20and%20archive%20boxes%20with%20warm%20library%20lighting%2C%20cream%20and%20brown%20tones%2C%20film%20grain%2C%20shallow%20depth%2C%20cohesive%20moody%20palette&width=520&height=320&seq=hero-stack-9h1&orientation=landscape',
  },
  {
    name: '专题话题', id: '专题话题', desc: '每一场热议都有讨论帖，理性吃瓜到站内继续', num: '3.4k', cat: '社区向',
    img: 'https://readdy.ai/api/search-image?query=editorial%20photography%20of%20overlapping%20chat%20bubble%20notes%20and%20paper%20pegs%20on%20a%20warm%20cork%20board%2C%20amber%20and%20brown%20tones%2C%20film%20grain%2C%20shallow%20depth%2C%20cohesive%20moody%20palette&width=520&height=320&seq=hero-topic-9h1&orientation=landscape',
  },
];

export default function HeroBand() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-8 md:px-6 md:py-10">
        {/* lead line */}
        <div className="mb-6 flex flex-col gap-3 md:mb-7 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-secondary-200 px-3 py-1 text-xs font-bold text-secondary-900">
              <i className="ri-focus-3-line flex h-4 w-4 items-center justify-center" />分类专区 · 按类整理
            </span>
            <h1 className="font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl">
              娱乐黑料、网红黑料、事件专区，
              <br className="hidden sm:block" />
              想找哪块 <span className="text-primary-600">直接进</span>
            </h1>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            9黑料网把散落的娱乐黑料、网红黑料与专题话题按类归档，事件专区铺全脉络、黑料盘点做主题榜单。按板块直进，不用翻大海捞针。
          </p>
        </div>

        {/* entry strip cards */}
        <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-5">
          {entries.map((e) => (
            <a
              key={e.name}
              href={`#${e.id}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200 transition hover:-translate-y-1 hover:ring-primary-300"
            >
              <div className="relative h-28 w-full overflow-hidden md:h-32">
                <img src={e.img} alt={`${e.name}专区分类入口`} title={`${e.name}专区`} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent" />
                <span className="absolute left-2.5 top-2.5 rounded-sm bg-accent-500 px-1.5 py-0.5 font-label text-[11px] tracking-wide text-foreground-950">
                  {e.cat}
                </span>
                <span className="absolute bottom-2.5 right-2.5 rounded-sm bg-background-50/90 px-1.5 py-0.5 font-label text-xs text-primary-700">
                  {e.num}
                </span>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{e.name}</h3>
                <p className="mt-1.5 line-clamp-2 min-h-[40px] text-xs leading-5 text-foreground-600">{e.desc}</p>
                <span className="mt-2.5 inline-flex items-center gap-1 text-xs font-bold text-primary-600 transition group-hover:gap-2">
                  进专区 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}